import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useMe } from '@/lib/api/queries';
import { useSessionStore } from '@/stores/session';
import { Spinner } from '@/components/Misc';
import { isApiError } from '@/lib/api/errors';

/** Loads `GET /auth/me` once and gates member routes; 401 → /login?next=. */
export function RequireAuth() {
  const me = useMe();
  const setMe = useSessionStore((s) => s.setMe);
  const loc = useLocation();
  useEffect(() => {
    if (me.data) setMe(me.data);
  }, [me.data, setMe]);
  if (me.isPending)
    return (
      <div className="flex h-full items-center justify-center text-fg-muted">
        <Spinner size={20} />
      </div>
    );
  if (me.isError) {
    if (isApiError(me.error) && me.error.status === 401) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
    return (
      <div className="flex h-full flex-col items-center justify-center gap-2 text-sm text-fg-muted">
        <p>Could not load your session.</p>
        <button type="button" className="text-accent hover:underline" onClick={() => me.refetch()}>
          Retry
        </button>
      </div>
    );
  }
  return <Outlet />;
}
